const twitter = {
  state: {
    serviceId: ''
  },
  mutations: {
    SET_SERVICEID(state, id) {
      state.serviceId = id
    }
  }
}
export default twitter
